import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PartnerListingEditor } from "@/components/partner/PartnerListingEditor";

const tabSchema = z.object({
  // TanStack parses `?new=1` into the NUMBER 1, so accept both and normalise.
  tab: z.enum(["profile", "photos", "status", "contract", "services", "events", "changes"]).optional().catch(undefined),
  new: z.union([z.string(), z.number(), z.boolean()]).optional().transform((v) => (v === undefined ? undefined : String(v))).catch(undefined),
});

export const Route = createFileRoute("/_authenticated/partner/$clientId")({
  head: () => ({ meta: [{ title: "Partner Dashboard — What Finland" }, { name: "robots", content: "noindex,nofollow" }] }),
  validateSearch: (s) => tabSchema.parse(s),
  component: PartnerDetail,
});

function PartnerDetail() {
  const { clientId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <PartnerListingEditor
      clientId={clientId}
      initialTab={search.tab ?? "profile"}
      autoOpenEvent={search.new === "1"}
      variant="page"
    />
  );
}
